// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * The events XML family, detected from the form of its first event.
 */
export enum EventFamily {
  Unspecified = 0,
  Events2005 = 1,
  Eventlog2007 = 2,
}
